const getRandom = (o, n) => {
  if (n === null) {
    n = o;
    o = 0;
  }
  return o + Math.floor(Math.random() * (n - o + 1));
};

export default () => {
  const arr = [];
  for (let i = 0; i < 16; i++) {
    arr.push(getRandom(0, 9));
  }

  const arr1 = [];
  for (let i = 0; i < 5; i++) {
    arr1.push(getRandom(0, 9));
  }

  const arr2 = [];
  for (let i = 0; i < 5; i++) {
    arr2.push(getRandom(0, 9));
  }

  return `${new Date().getTime()}_${arr.join('')}_${arr1.join('')}mp${arr2.join('')}`;
};
